import React from 'react';
import { Entity, FilterDefinition, FiltersValues } from '../types';
import { FilterEntry } from './filterEntry';

interface FilterGroupComponentProps {
  code: string;
  label: string;
  definitions: FilterDefinition[];
  values: FiltersValues;
  onChange: (name: string, values: Entity[]) => void;
  getIsDisabled: (definitionName: string) => boolean;
}

function FilterGroups(props: FilterGroupComponentProps) {
  if (props.definitions.length === 0) {
    return null;
  }

  return (
    <>
      {props.definitions.map(def => (
        <FilterEntry
          key={def.name}
          definition={def}
          values={props.values[def.name]}
          disabled={props.getIsDisabled(def.name)}
          onChange={props.onChange}
        />
      ))}
    </>
  );
}

export { FilterGroups };
